export * from './show';

import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { CompanyAndAgent } from '~/components/connections/types';

type IndexParams = {
  license: string;
  company_side: 'seller' | 'buyer';
  period: Period;
  limit: number;
  page: number;
  sort_field: string;
  order: Order;
};

type IndexResponse = {
  data: {
    seller_companies: CompanyAndAgent[];
    seller_companies_count: number;
    buyer_companies: CompanyAndAgent[];
    buyer_companies_count: number;
    seller_companies_volume: number;
    seller_companies_units: number;
    buyer_companies_volume: number;
    buyer_companies_units: number;
  };
};

export const index = async ({ license, sort_field, order, ...params }: IndexParams) =>
  apiClient.get<IndexResponse>(
    `/companies/${license}/realtor_companies?sort[field]=${sort_field}&sort[order]=${order}`,
    { params, timeout: 25000 } // temporary fix for heavy Connections page queries
  );
